import { render } from "./FooterTemplate.vue?vue&type=template&id=5fd7bd1a&scoped=true"
import script from "./FooterTemplate.vue?vue&type=script&lang=js"
export * from "./FooterTemplate.vue?vue&type=script&lang=js"

import "./FooterTemplate.vue?vue&type=style&index=0&id=5fd7bd1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd7bd1a"]])

export default __exports__